
import {throwError as observableThrowError, interval as observableInterval,
  Observable
} from 'rxjs';
import {
  Injectable
}      from '@angular/core';
import {
  JwtHelperService
} from '@auth0/angular-jwt';

import {
  AppConstant
}     from '../../app.constant';

import {
  HttpClient, HttpResponse
} from '@angular/common/http';

import {
  UserContext
} from '../user-context';

import {
  Router
} from '@angular/router';

import * as auth0 from 'auth0-js';
import * as moment from 'moment';
import {LocationSummaryService} from '../location-summary-service';
import {ApiService} from '../api';
import {UserToken} from '../../models';
import {ClientsService} from '../../clients/clients.service';

@Injectable()
export class AuthService {
  // Configure _auth0
  private auth0 = new auth0.WebAuth({
    domain: AppConstant.auth0.domain,
    clientID: AppConstant.auth0.clientID
  });
  private refreshTokenObservable = observableInterval(2700000); // 45 minutes
  private refreshTokenSubscription: any;

  constructor(private httpClient: HttpClient,
              private userContext: UserContext,
              private clientService: ClientsService,
              private jwtHelperService: JwtHelperService,
              private locationService: LocationSummaryService,
              private api: ApiService,
              private router: Router) {
  }

  public handleAuthentication(): void {
    //console.log("Handling authentication...");
      this.checkRefreshToken();

      this.refreshTokenSubscription = this.refreshTokenObservable.subscribe(() => {
        this.refreshToken();
      });
  }

  public checkRefreshToken() {
    let token = this.userContext.token;
    if (token && token.refreshToken) {
      if ( this.jwtHelperService.isTokenExpired(token.idToken) && token.refreshToken ) {
        if (this.refreshTokenSubscription) {
          this.refreshTokenSubscription.unsubscribe();
        }
        this.refreshTokenSubscription = this.refreshTokenObservable.subscribe(() => {
          this.refreshToken();
        });
        this.refreshToken();
      } else {
        console.log("token not expired. continuing.");
      }
    } else {
      this.userContext.clear()
    }
  }

  public login(username: string, password: string, cb: any): void {
    this.auth0.client.login({
      realm: AppConstant.auth0.connection,
      username,
      password,
      scope: 'openid profile email name role account_id reference offline_access'
    }, (err, authResult) => {
      if (err) {
        if (cb) {
          cb(err);
        }
      } else {
        this.setSession(authResult);
        if (cb) {
          cb(null);
        }
      }
    });
  }

  public isAuthenticated(): boolean {
    let userToken = this.userContext.token;
    return userToken && !this.jwtHelperService.isTokenExpired(userToken.idToken);
  }

  public hasRole(roleName: string) {
    return this.userContext.hasRole(roleName);
  }

  public getToken(): string {
    if( this.userContext.token )
      return this.userContext.token.idToken;
    else return null;
  }

  public logout(): void {
    if (this.refreshTokenSubscription) {
      this.refreshTokenSubscription.unsubscribe();
    }
    this.userContext.clear();
    this.locationService.clear();
    this.clientService.clear();
    this.router.navigate(['auth', 'login']);
  }

  /**
   * Auth forgot
   * @param email
   * @param cb
   */
  public forgotPassword(email, cb) {
    this.auth0.changePassword({
      connection: AppConstant.auth0.connection,
      email
    }, cb);
  }

  private setSession(authResult): void {
    console.log("Setting session with: " + JSON.stringify(authResult));
    this.userContext.clear();
    this.userContext.token = authResult;
    this.userContext.fetchAccount();
  }

  private refreshToken() {
    let currentRefreshToken = this.userContext.token.refreshToken;
    const data = {
      client_id: AppConstant.auth0.clientID,
      grant_type: 'refresh_token',
      refresh_token: this.userContext.token.refreshToken,
      scope: 'openid profile email name role account_id reference offline_access'
    };
    // Call api to get new id_token
    console.log("Current expiration: " + this.jwtHelperService.getTokenExpirationDate(this.userContext.token.idToken));
    this.httpClient.post(`https://${AppConstant.auth0.domain}/oauth/token`, data)
      .subscribe((token: any) => {
        this.userContext.token = UserToken.parse(token);
        if(!this.userContext.token.refreshToken) {
          this.userContext.token.refreshToken = currentRefreshToken;
        }
        console.log("Refreshed token at " + moment() + " with: " + JSON.stringify(token) + " now expires at " +  this.jwtHelperService.getTokenExpirationDate(this.userContext.token.idToken));
      }, (error) => {
        console.log(`error refreshing token ${JSON.stringify(error)}`);
        this.handleError(error);
      });
  }

  private handleError(error: Response) {
    if (this.refreshTokenSubscription) {
      this.refreshTokenSubscription.unsubscribe();
    }
    this.userContext.clear();
    this.locationService.clear();
    this.router.navigate(['auth', 'login']);
    return observableThrowError(error.json());
  }
}
